__turbopack_context__.v({
  "continueTile": "RecentlyViewed-module__TwibHG__continueTile",
  "continueTileIcon": "RecentlyViewed-module__TwibHG__continueTileIcon",
  "does-not-exist": "RecentlyViewed-module__TwibHG__does-not-exist",
  "item": "RecentlyViewed-module__TwibHG__item",
  "js-has-pseudo": "RecentlyViewed-module__TwibHG__js-has-pseudo",
  "lastSearch": "RecentlyViewed-module__TwibHG__lastSearch",
  "list": "RecentlyViewed-module__TwibHG__list",
  "title": "RecentlyViewed-module__TwibHG__title",
  "trackElement": "RecentlyViewed-module__TwibHG__trackElement",
  "wrapper": "RecentlyViewed-module__TwibHG__wrapper",
});
